import React from 'react';
import config from 'react-global-configuration';

import Card from '../../../../components/Molecules/Card';
import './style.scss';

const NodeResearchTeaser = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'summary']);
  const image = entity.getIn(['field_media_image', 0, 'styles', 'paragraph_image'], null);
  const imageAlt = entity.getIn(['field_media_image', 0, 'alt'], '');
  const language = config.get('DEFAULT_LANGUAGE');
  const type = entity.getIn(['type', 0, 'target_id'], null);
  const link = entity.getIn(['paths', language], entity.get('paths').first());
  return <Card title={title} image={image} alt={imageAlt} body={body} type={type} link={link} />;
};

export default NodeResearchTeaser;
